import { z } from 'zod';

export const ValidationErrorSchema = z.looseObject({
  type: z.string(),
  title: z.string(),
  status: z.int(),
  errors: z.record(z.string(), z.any()).optional(),
  traceId: z.string().optional(),
});

export const ProblemDetailsErrorSchema = z.looseObject({
  // URI reference that identifies the problem type
  type: z.string(),
  // short, human-readable summary of the problem type.It SHOULD NOT change from occurrence to occurrence
  // of the problem, except for purposes of localization
  title: z.string(),
  // HTTP status code generated by the origin server for this occurrence of the problem
  status: z.int(),
  // human-readable explanation specific to this occurrence of the problem
  detail: z.string(),
  // a URI reference that identifies the specific occurrence of the problem
  instance: z.string(),
  // error code denoting specific error reason
  errorCode: z.string(),
  // there can be extra values here - need to parse this with z.looseObject() option to not truncate props!
  errors: z.record(z.string(), z.any()).optional(),
  message: z.string().optional(),
});

export const ProblemDetailsValidationErrorSchema = z.object({
  // URI reference that identifies the problem type
  type: z.literal('https://httpstatuses.io/400'),
  // short, human-readable summary of the problem type.It SHOULD NOT change from occurrence to occurrence
  // of the problem, except for purposes of localization
  title: z.string(),
  // HTTP status code generated by the origin server for this occurrence of the problem
  status: z.int(),
  // human-readable explanation specific to this occurrence of the problem
  detail: z.string(),
  // a URI reference that identifies the specific occurrence of the problem
  instance: z.string(),
  // error code denoting specific error reason
  errorCode: z.string(),
  // TODO: validation stuff goes here
});
export const ProblemDetailsErrorNullishSchema =
  ProblemDetailsErrorSchema.nullish();

export type ProblemDetailsErrorModel = z.infer<
  typeof ProblemDetailsErrorSchema
>;
export type ProblemDetailsErrorCreateModel = z.infer<
  typeof ProblemDetailsErrorNullishSchema
>;
export type ValidationErrorModel = z.infer<typeof ValidationErrorSchema>;
